import { adminHttpClient } from '../../../commons/adminHttpClient'

export type RenewalPerksEmployeeRequest = {
    id: string
    classId: string
}

export const savePerksEmployeesToRenewalClasses = (payload: RenewalPerksEmployeeRequest[]): Promise<any> => {
    return adminHttpClient.put('/Benefit/BenefitRenewal/Perks/SaveEmployeesWithRenewalClasses', {
        listEmployeeWithRenewalClasses: payload,
    })
}

export default savePerksEmployeesToRenewalClasses
